<template>
	<div
		class="banner-upload"
		v-loading="loading"
		element-loading-text="图片上传中"
		element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<el-tooltip
			effect="dark"
			content="上传成功!"
			placement="top"
			v-model="tooltipShow"
			:manual="true">
			<p></p>
		</el-tooltip>
		<p class="error-msg" v-show="uploadError">上传失败,请重新上传!</p>
		<div v-if="previewSrc === ''" class="banner-add el-icon-plus" @click="uploadHandler"></div>
		<div v-else class="img-preview-block" @mouseover="imgMouseOver" @mouseout="imgMouseOut">
			<w-image :src="previewSrc" alt="" class="img-preview" @click="uploadHandler"></w-image>
			<div class="img-btn" v-show="activeFlag">
				<el-button type="primary" size="small" @click="uploadHandler"><i class="el-icon-upload el-icon--right"></i></el-button>
				<el-button type="danger" size="small" @click="deleteClick"><i class="el-icon-delete el-icon--right"></i></el-button>
			</div>
		</div>
		<input type="file" ref="file" id="file" accept="image/png,image/jpeg,image/jpg" v-show="false" @change="getFile">
		<!-- <p style="color:#606266b5">80*80,1M以内，png/jpg/jpeg格式</p> -->
	</div>
</template>

<script>
export default {
	name: 'bannerUpload',
	props: {
		imgSrc: {
			type: String,
			default: ''
		},
		dataid: String,
		uploadError: Boolean,
		from: String,
		editDisable: {
			type: Boolean,
			default: true
		}
	},
	data () {
		return {
			isChange: false,
			previewSrc: '',
			fileName: '',
			file: '',
			type: '',
			uploadType: new RegExp(/image\/png|image\/jpg|image\/jpeg/),
			uploadTypeText: 'png,jpg,jpeg',
			uploadSize: 1,
			activeFlag: false,
			loading: false,
			tooltipShow: false,
			tooltipTimer: null
		}
	},
	watch: {
		imgSrc (val) {
			this.previewSrc = val
			this.$refs.file.value = ''
			this.$emit('update:uploadError', false)
		}
	},
	created () {
		this.previewSrc = this.imgSrc
	},
	methods: {
		flagChange () {
			this.isChange = false
		},
		imgMouseOver () {
			if (this.editDisable) {
				this.activeFlag = true
			}
		},
		imgMouseOut () {
			this.activeFlag = false
		},
		uploadHandler () {
			if (this.editDisable) {
				this.$refs.file.click()
			}
		},
		getFile (e) {
			this.isChange = true
			this.activeFlag = false
			let files = e.target.files[0]
			let type = files.type
			let size = files.size / 1024 / 1024
			this.fileName = files.name
			let a = []
			a = this.fileName.trim().split('.')
			this.file = files
			this.type = a[a.length - 1]
			if (!this.uploadType.test(type)) {
				this.$message.error(`上传图片只支持${this.uploadTypeText}格式!`)
				return false
			}
			if (size > this.uploadSize) {
				this.$message.error(`上传图片大小不能超过${this.uploadSize}M!`)
				return false
			}
			if (!e || !window.FileReader) {
				return false
			}
			let formData = new FormData()
			// formData.append('extension', this.$refs.file.files[0].type.split('/')[1])
			formData.append('file', this.file)
			this.$store.dispatch('requestFilePost', {
				// url: `${this.$fxBaseApi.urlQIVShop}/upload/pic/tempcompression`,
				url: '/quickorder/ns/v1/shop/tenpay/upload',
				data: formData
			}).then(res => {
				if (res.result) {
					// console.log(res.data)
					this.showTooltip()
					this.$emit('saveImgData', res.data)
					this.$emit('update:uploadError', false)
					this.$emit('updateImg', { type: 'add' })
					this.$emit('getFormData', { extension: this.type, oldUrl: this.imgSrc, newUrl: res.data })
					let reader = new FileReader()
					reader.readAsDataURL(files)
					reader.onloadend = () => {
						let image = new Image()
						image.src = reader.result
						this.$emit('update:imgSrc', '')
						// console.log(reader.result)
						image.onload = () => {
							this.previewSrc = reader.result
						}
					}
				} else {
					this.$message.error('上传图片失败')
					this.deleteClick()
					this.$emit('update:uploadError', true)
				}
			}).catch(() => {
				this.deleteClick()
				this.$emit('update:uploadError', true)
			})
		},
		deleteClick () {
			this.isChange = this.from !== 'store'
			this.previewSrc = ''
			this.imgSrc = ''
			this.$refs.file.value = ''
			this.file = ''
			this.$emit('delete')
		},
		returnSrc () {
			this.$refs.file.value = ''
			this.previewSrc = this.imgSrc
		},
		uploadImgHandler () {
			if (!this.imgSrc) {
				this.imgSrc = ''
			}
			return new Promise((resolve, reject) => {
				this.loading = true
				var formData = new FormData()
				formData.append('dataid', this.dataid)
				formData.append('oldUrl', this.imgSrc)
				formData.append('extension', this.type)
				formData.append('file', this.file)
				if (!this.isChange) {
					this.loading = false
					if (this.imgSrc === '') {
						this.$emit('isFalse', true)
						return false
					}
					this.$emit('update:imgSrc', this.imgSrc)
					this.$emit('update:uploadError', false)
					if (this.from) {
						this.$emit('getFormData', { file: '', extension: '', oldUrl: '' })
					} else {
						this.$emit('save', this.imgSrc)
					}
				} else {
					if (this.from) {
						this.loading = false
						this.$emit('getFormData', { file: this.file, extension: this.type, oldUrl: this.imgSrc })
					} else {
						if (this.file === '') {
							this.loading = false
							this.$emit('isFalse', true)
							return false
						}
						this.$store.dispatch('requestFilePost', {
							url: `${this.$fxBaseApi.urlQIVShop}/organ/upload`,
							data: formData
						}).then(res => {
							if (res.result) {
								this.$emit('update:imgSrc', res.data)
								this.$emit('update:uploadError', false)
								this.$emit('save', res.data)
								resolve(res.data)
							} else {
								this.$message.error('上传图片失败')
								this.$emit('update:uploadError', true)
								reject(res)
							}
						}, error => {
							this.$emit('update:uploadError', true)
							reject(error)
						}).always(() => {
							this.loading = false
						})
					}
				}
			})
		},
		showTooltip () {
			this.tooltipShow = true
			if (this.tooltipTimer) {
				clearTimeout(this.tooltipTimer)
			}
			this.tooltipTimer = setTimeout(() => {
				this.tooltipShow = false
			}, 1500)
		}
	}
}
</script>
<style lang="stylus" scoped>
.banner-upload {
	width: 170px;
	height: 110px;
	overflow: hidden;
	box-sizing:border-box
	position:relative
	.error-msg {
		color:red;
		position:absolute;
		top:0;
		left:41px
	}
	.banner-add,.img-preview-block {
		border-radius: 6px;
		overflow: hidden;
		box-sizing:border-box;
		width: 170px;
		height: 110px;
		line-height: 110px;
		background-color :#fff;
		display: inline-block
	}
	.banner-add {
		border: 1px dashed #d9d9d9;
		cursor: pointer;
		position: relative;
		text-align: center;
		font-size: 28px;
		color: #8c939d;
		&:hover {
			border-color: var(--fx-primary-color);
		}
	}
	.img-preview-block {
		position:relative;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		.img-preview {
			width:100%;
			height:100%;
		}
		.img-btn {
			position: absolute;
			top:0px;
			right:0px;
			height:100%;
			width:100%;
			background-color:rgba(0,0,0,0.1)
		}
	}
}
</style>
